// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__FzWe5","text":"style_text__R+DnJ","description":"style_description__zQOG3","actions":"style_actions__Et0gx","actions_btn":"style_actions_btn__oIxov"};